import { render } from "./BonAPIResults.vue?vue&type=template&id=cfa28628&scoped=true"
import script from "./BonAPIResults.vue?vue&type=script&lang=js"
export * from "./BonAPIResults.vue?vue&type=script&lang=js"

import "./BonAPIResults.vue?vue&type=style&index=0&id=cfa28628&scoped=true&lang=scss"

import exportComponent from "/Users/james/Desktop/VueJS/ingredient-swap/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cfa28628"]])

export default __exports__